import { render, staticRenderFns } from "./HighSchool.vue?vue&type=template&id=ee487ec2&scoped=true"
import script from "./HighSchool.vue?vue&type=script&lang=js"
export * from "./HighSchool.vue?vue&type=script&lang=js"
import style0 from "./HighSchool.vue?vue&type=style&index=0&id=ee487ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee487ec2",
  null
  
)

export default component.exports